import TracedLogo from '../../design/TracedLogo'

/** Our signature, small and to the side: the shop's brand is the canvas. */
export default function StageFooter() {
  return (
    <div className="flex shrink-0 items-center space-x-cfd-2">
      <TracedLogo tone="dark" className="h-[clamp(22px,3.6vh,38px)]" />
      {/* No room for the address beside the strip's words on a handheld. */}
      <span aria-hidden="true" className="h-[clamp(16px,2.6vh,26px)] w-px bg-divider handheld:hidden" />
      <span className="font-volte text-cfd-label lowercase tracking-[0.12em] text-text-mid handheld:hidden">llpos.dk</span>
    </div>
  )
}
